

<div class="_dialog-title">
	<mat-icon svgIcon="logo" class="mr-2"></mat-icon>
	<span>{{'sign_update_message' | translate}}</span>
</div>


<div class="_dialog-content">
	<form (ngSubmit)="apply(challengeForm)" #challengeForm="ngForm" class="">

		<p>
			{{'enter_code_message' | translate}}
			<span style="display:block" class="ltr-field">{{data.phone | phone}}</span>
		</p>

		<mat-form-field color="accent" appearance="outline">
			<mat-label>{{'verification_code' | translate}}</mat-label>
			<input autocomplete="off" matInput placeholder="{{'' | translate}}" [(ngModel)]="verificationCode" name="verificationCode" required type="tel" pattern="[0-9]*" [maxlength]="data.maxLength || 4">
			<mat-icon matSuffix (click)="verificationCode = null" *ngIf="verificationCode">close</mat-icon>
		</mat-form-field>


		<div class="text-far" style="position:relative; top: -8px; margin-bottom: 15px;">
			<button type="button" mat-button disabled *ngIf="timer > 0" disabled>
				<div style="display:flex; align-items:center">
					<span class="mr-2">{{'resend' | translate}}:</span>
					<span>{{timer}}</span>
				</div>
			</button>
			<button mat-button (click)="resendPinCode()" color="accent" *ngIf="timer === 0">{{'resend' | translate}}</button>
		</div>

		<div class="_bottom-actions">
			<button mat-button class="_cancel" mat-dialog-close>{{'Cancel' | translate}}</button>
			<button type="submit" mat-button color="accent">{{'continue' | translate}}</button>
		</div>
	</form>
</div>




